import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "bootstrap";
import store from "./store";
import LoadScript from "vue-plugin-load-script";

import VueLazyload from "vue-lazyload";

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: "../../assets2/img/error.png",
  loading: "../../assets2/img/loader.gif",
  attempt: 1
});

Vue.use(LoadScript);
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.loggedIn) {
      store
        .dispatch("storeRedirectPath", {
          path: to
        })
        .then(() => {
          next({
            path: "/login"
          });
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.requiresVisitor)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (store.getters.loggedIn) {
      next({
        path: "/"
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
